/**
 * 功能: 恢复报告中的数据
 * 删除关联数据的时候, 有时候不需要删除的被删除了 需要对数据进行恢复下
 */
<template lang="pug">
  #recycler
    el-form(ref="form" :model="formData" label-width="80px")
      el-col(:span="4")
        el-form-item(label="类型")
          el-select(v-model="formData.type" placeholder="请选择" :size="GLOBAL.SIZE_OF_INPUTBOX")
            el-option(v-for="item in options" :key="item.value" :label="item.label" :value="item.value")
      el-col(:span="6")
        el-form-item(label="id")
          el-input(:size="GLOBAL.SIZE_OF_INPUTBOX" v-model="formData.id")
      el-col(:span="2")
        el-form-item
          el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" type="primary" @click="recover") 恢复

</template>

<script>
import apis from '@/apis/apis'
export default {
  name: 'Recycler',

  data () {
    return {
      options: [
        { value: 'brief', label: '报告' },
        { value: 'glossary', label: '名词解释' },
        { value: 'outline', label: '目录' },
        { value: 'section', label: '段落' },
        { value: 'sizepro', label: '数说' },
        { value: 'ill', label: '图说' },
        { value: 'quote', label: '专家说' },
        { value: 'table', label: '表说' },
        { value: 'element', label: '元素' },
        { value: 'slide', label: '幻灯片' },
        { value: 'article', label: '文章' },
        { value: 'video', label: '解说' },
        { value: 'individual', label: '个人' },
        { value: 'team', label: '团队' },
        { value: 'updateLog', label: '报告更新日志' }
      ],
      formData: { id: null, type: 'brief' }
    }
  },
  methods: {
    // 根据录入的id和类型恢复数据
    recover () {
      if (!this.formData.id) return this.$message({ type: 'error', message: 'id格式不合法' })
      apis.recovery(this.formData).then(res => {
        if (res.errCode === 0) {
          if (res.data) {
            this.$message({ type: 'success', message: '恢复成功' })
          } else {
            this.$message({ type: 'success', message: '数据已经成功恢复！' })
          }
        } else {
          this.$message({ type: 'error', message: res.msg })
        }
      })
    }
  }
}
</script>

<style>

</style>
